import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from "@angular/material";

@Component({
	selector: 'app-dialog-confirmar-sair',
	templateUrl: './dialog-confirmar-sair.component.html',
	styleUrls: ['./dialog-confirmar-sair.component.scss']
})
export class DialogConfirmarSairComponent implements OnInit {

	constructor(public dialogRef: MatDialogRef<DialogConfirmarSairComponent>) {

	}

	ngOnInit() {
		this.dialogRef.disableClose = true;
	}

	sair(sair_sem_salvar: boolean): void{
		this.dialogRef.close({sair_sem_salvar: sair_sem_salvar});
	}

}
